import React, { useEffect, useRef } from 'react';

import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import XYZ from 'ol/source/XYZ';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import Circle from 'ol/geom/Circle';
import { Style, Icon, Fill, Stroke } from 'ol/style';
import { fromLonLat, toLonLat } from 'ol/proj';
import Translate from 'ol/interaction/Translate';
import MouseWheelZoom from 'ol/interaction/MouseWheelZoom';
import PinchZoom from 'ol/interaction/PinchZoom';
import DragPan from 'ol/interaction/DragPan';
import { defaults as defaultControls, Zoom, Attribution, FullScreen } from 'ol/control';
import { defaults as defaultInteractions } from 'ol/interaction';
import { platformModifierKeyOnly } from 'ol/events/condition';
import styles from "../mapLocationPicker.scss"
import { getImageUrl } from '../../../../services/asset';
import { useFullscreenCenterOnExit } from './useFullscreenCenterOnExit';
import { useInitializeMap } from './useInitializeMap';
import { useMarkerLayer } from './useMarkerLayer';
import { useTranslateAndClick } from './useTranslateAndClick';




export const useOpenLayerMap = (mapElementName, value, handleChange) => {
  const locationFeatureRef = useRef(null);
  const isDraggingFeature = useRef(false);
  const translateRef = useRef(null);
  const { latitude, longitude } = value;

  const mapInstance = useInitializeMap(mapElementName, value)
  useMarkerLayer(mapInstance, value, isDraggingFeature, translateRef, locationFeatureRef)
  useTranslateAndClick(mapInstance, value, handleChange, translateRef, locationFeatureRef, isDraggingFeature)

  const handleReturnToLocation = () => {
    const coordinates = fromLonLat([longitude, latitude]);

    if (mapInstance && coordinates && locationFeatureRef.current) {
      // Update the marker/circle position
      const geometry = locationFeatureRef.current.getGeometry();

      if (geometry instanceof Point) {
        geometry.setCoordinates(coordinates);
      } else if (geometry instanceof Circle) {
        geometry.setCenter(coordinates);
      }

      // Animate the view to the new location
      mapInstance.getView().animate({
        center: coordinates,
        zoom: 15,
        duration: 500
      });
    }
  };

  useEffect(handleReturnToLocation, [latitude, longitude])

  // Listen for fullscreen changes and return to location when exiting fullscreen
  useFullscreenCenterOnExit(latitude, longitude, handleReturnToLocation)




  return {
    handleReturnToLocation
  }

}


// WEBPACK FOOTER //
// ./src/containers/AdFormPage/LocationSelector/hooks/useOpenLayerMap.ts